import { useEffect, useState } from 'react';
import { OfferCarCard } from './offerCarCard';
import { Pagination } from '../ui/Pagination';
import Container from '../elements/container';

let perPage = 4;
export const OffersListing = ({ ordersList }) => {
  const [currentList, setCurrentList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    if (ordersList) {
      setTotalPages(Math.ceil(ordersList.length / perPage));
    }
  }, [ordersList]);

  useEffect(() => {
    const copyList = [...ordersList];
    const startIndex = currentPage * perPage;
    const endIndex = startIndex + perPage;
    const updatedList = copyList.slice(startIndex, endIndex);
    setCurrentList(updatedList);
  }, [currentPage, ordersList]);

  return (
    <div className="container mx-auto items-center justify-center flex flex-col">
      {ordersList.length === 0 ?
        <p>Δεν έχεις αυτοκίνητα αυτή τη στιγμή. Μπες στο <a href='https://www.myavis.gr/el' className='text-[#D4002A]'>myavis</a> για να ξεκινήσεις.</p>
        :
        <>
          <div className="max-lg:pt-8 lg:pt-16 grid lg:grid-cols-2  gap-6 justify-center items-center">
            {currentList.map((item, index) => (
              <OfferCarCard carInfo={item} key={index} />
            ))}
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
          /> 
        </>
      }
    </div>
  );
};
